import { render, staticRenderFns } from "./ATabs.vue?vue&type=template&id=7eb87e2c"
import script from "./ATabs.vue?vue&type=script&lang=js"
export * from "./ATabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports